angular.module('impactx.MenuDirectives').directive('ixDeactivateRFQSSearch', function() {
    return {
        restrict: 'E',
        controller: 'DeactivateRFQSSearchCtrl',
        controllerAs: 'deactivateRFQSSearchCtrl',
        templateUrl: 'shared/menu/templates/deactivaterfqssearch.tmpl.html'
    }
});